import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer>
      <Link to="/" className="nav-logo">HEYIM<span>PURP</span></Link>
      <div className="footer-links">
        <Link to="/portfolio">Projets</Link>
        <Link to="/tarification">Tarification</Link>
        <Link to="/contact">Contact</Link>
      </div>
      <p className="footer-copy">© 2026 HeyImPurp — Tous droits réservés</p>
    </footer>
  );
}
